/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-2",
    "aws_cognito_identity_pool_id": "us-east-2:49a3b1a9-77a2-4dfa-a45c-3dca9aa602e6",
    "aws_cognito_region": "us-east-2",
    "aws_user_pools_id": "us-east-2_8CbWESVJA",
    "aws_user_pools_web_client_id": "3b9qcg2ttjqseeuscnueuqegp7",
    "oauth": {
        "domain": "webed8f77b8-ed8f77b8-master.auth.us-east-2.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://www.chilempleo.cl/signin/callback/,http://localhost:8080/signin/callback/",
        "redirectSignOut": "https://www.chilempleo.cl/signout/,http://localhost:8080/signout/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;



// WEBPACK FOOTER //
// ./src/aws-exports.js